module.exports = __webpack_public_path__ + "img/c04_unitstartechnetlures_Normal_ua.c83eb462.webp";